import React from "react";
import {
  MobileHotelShopRoomTypePickerPanel as SharedMobileHotelShopRoomTypePickerPanelComponent,
  MultiroomSuffixText,
} from "halifax";
import { RouteComponentProps } from "react-router";
import { CorpRoomInfoProducts } from "redmond/build/capone-corporate";
import { getConfigTenant, isCorpTenant, useIsTravelApp } from "@capone/common";
import { getRoomPolicyComplianceType } from "@capone/common/src/utils/hotelShopPolicyCompliance";
import { HotelShopStep } from "../../reducer/state";
import { config } from "../../../../api/config";
import { MobileHotelShopRoomTypePickerPanelConnectorProps } from "./container";

export interface MobileHotelShopRoomTypePickerPanelProps
  extends MobileHotelShopRoomTypePickerPanelConnectorProps,
    RouteComponentProps {
  onContinueClicked?: () => void;
  showPolicyBanner?: boolean;
}

export const MobileHotelShopRoomTypePickerPanel = (
  props: MobileHotelShopRoomTypePickerPanelProps
) => {
  const {
    setHotelShopProgress,
    rewardsKey,
    onContinueClicked,
    roomInfoProducts,
    roomsCount,
    showPolicyBanner = true,
    cheapestProduct,
    history,
  } = props;

  React.useEffect(() => {
    const footer = document.querySelector(
      ".mclean-generic-footer"
    ) as HTMLElement;
    const fixedComponent = document.querySelector(
      ".mobile-hotel-shop-price-panel"
    ) as HTMLElement;
    const travelWalletDrawerButton = document.querySelector(
      ".travel-wallet-button"
    ) as HTMLElement;
    if (fixedComponent && footer) {
      footer.style.paddingBottom = `${fixedComponent.clientHeight}px`;
    }
    if (fixedComponent && travelWalletDrawerButton) {
      travelWalletDrawerButton.style.bottom = `${
        fixedComponent.clientHeight + 20
      }px`;
    }
    return () => {
      if (footer) {
        footer.style.paddingBottom = "85px";
      }
      if (travelWalletDrawerButton) {
        travelWalletDrawerButton.style.bottom = isCorpTenant(config.TENANT)
          ? "130px"
          : "100px";
      }
    };
  }, [rewardsKey]);

  const { isTravelApp } = useIsTravelApp();

  return (
    <SharedMobileHotelShopRoomTypePickerPanelComponent
      {...props}
      onClickContinue={() => {
        setHotelShopProgress(HotelShopStep.ChooseRoom);
        if (isTravelApp) {
          const searchParams = new URLSearchParams(history.location.search);
          searchParams.set("shopStep", HotelShopStep.ChooseRoom);
          history.push({
            pathname: history.location.pathname,
            search: searchParams.toString(),
          });
        }

        if (onContinueClicked) {
          onContinueClicked();
        }
      }}
      className="b2b"
      policyComplianceType={getRoomPolicyComplianceType(
        roomInfoProducts as CorpRoomInfoProducts[]
      )}
      tenant={getConfigTenant()}
      showPrice
      suffixText={<MultiroomSuffixText roomsCount={roomsCount} />}
      showPolicyBanner={showPolicyBanner}
      cheapestProductOverride={cheapestProduct}
    />
  );
};
